export default {
    data() {
      return {
  
        radio: '1',
        search:'',
        shop_search:'',

        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',

      }
    },
     methods: {
          //获取项目名
          getshop_search(){
            this.$post('projects/shop_search', {
                      offset:0,  
                      length:999,
                       token: this.$store.state.authority_management,
            }).then(res => {
              this.shop_search = res.data.result.data

              // console.log(res.data.result.data)
            })
          },
          //获取辅导员姓名
          getsearch(){
            this.$post('instructor/search', {
                      offset:0,  
                      length:999,
                      token: this.$store.state.authority_management,
                      shop_id: this.$store.state.store.id
            }).then(res => {
              this.search = res.data.result.data
            })
          },

                
              // 提示消息
            tishi(text) {
              this.$message.error(text);
            },
        // 成功消息
        success(text) {
              this.$message({
                message: text,
                type: 'success'
              });
            },
          //添加班级
          add(){
          let fl = false
          let text = "请输入"
             // 校验
          if(this.value1 == ''|| this.value1 == null){
            text = text + '__[班级名称]'
            } 
            if(this.value2 == '' || this.value2 == null ){
            text = text + '__[项目名称]'
            } 
            if(this.value3 == ''  || this.value3  == null){
            text = text + '__[辅导员]'
            } 
            if(this.value5 == '' || this.value5 == null){
            text = text + '__[开班时间]'
            }
            if(text == '请输入'){
            fl = true
            }else{
            this.tishi(text)
            }

            if(fl){
                this.$post('class/create', {
                      name:           this.value1,
                      project_id:     this.value2,
                      instructor_id:  this.value3,
                      start_time:     this.value5,
                      token: this.$store.state.authority_management,
					  shop_id:this.$store.state.store.id
              }).then(res => {
                if(res.data.status=='success'){
                  this.success('添加成功！')
                }else{
                  this.tishi('添加失败！')
                }
                
              })
            }
            
          },
    },

    created(){

         this.getshop_search();
         this.getsearch();



    },
  }